import { useMutation } from '@tanstack/react-query'
import { multiFactorAuthorizationRequest } from 'services/MFAService'
import { BaseErrorResponse } from 'types/beneficiaries'

export const useMFAMutation = (onError?: (error: BaseErrorResponse, data) => void) => {
  return useMutation({
    mutationFn: multiFactorAuthorizationRequest,
    onError,
  })
}
